<template>
    <div class="box">
        <div class="tabbar" v-if="tabbarShow" :class="navBarFixed ? 'navBarFixed' : ''">
            <img @click="goback" src="../../../../static/common/logoBlack.png" alt="" />
            <div class="downloads" @click="downloads">
                下载APP
            </div>
        </div>
        <img class="banner" src="/activity/firstsignature/banner.png" alt="" />
        <img class="wapbanner" src="/activity/firstsignature/wap/banner.png" alt="" />

        <div id="login" ref="targetTops">

            <div class="login-flex">
                <div class="interactive">
                    <input v-model="form.phone" ref="inputElement" type="text" placeholder="请输入手机号"
                        @blur="changePhone" />
                    <div class="codeBox">
                        <input v-model="form.code" type="text" placeholder="请输入验证码" />
                        <span v-if="verControl" @click="verCode(form.phone)">获取验证码</span>
                        <span v-else>重新获取({{ verSecond }})</span>
                    </div>

                    <div class="buttom" @click="submit(form)">
                        <img src="/activity/firstsignature/button2.png" alt="">
                    </div>
                </div>
            </div>
            <div v-if="controlImgCodeDialog" class="codeDialog">
                <img :src="imgcodelocal" alt="" />
                <p>
                    <span>图形验证码:</span>
                    <input type="text" v-model="form.codeNumber" />
                </p>
                <div>
                    <button @click="() => {
                        this.controlImgCodeDialog = false;
                    }
                    ">
                        取消
                    </button>
                    <button @click="confirm(form.codeNumber)">确定</button>
                </div>
            </div>

        </div>
        <div :class="navBarFixed ? 'waplogin logins' : isApp ? 'waplogin waplogin1' : 'waplogin'" ref="targetTops">

            <div class="login-flex">
                <div class="interactive">
                    <input v-model="form.phone" ref="inputElement" type="text" placeholder="请输入手机号"
                        @blur="changePhone" />
                    <div class="codeBox">
                        <input v-model="form.code" type="text" placeholder="请输入验证码" />
                        <span v-if="verControl" @click="verCode(form.phone)">获取验证码</span>
                        <span v-else>重新获取({{ verSecond }})</span>
                    </div>

                    <div class="buttom" @click="submit(form)">
                        <img src="/activity/firstsignature/wap/button2.png" alt="">
                    </div>
                </div>
            </div>
            <div v-if="controlImgCodeDialog" class="codeDialog">
                <img :src="imgcodelocal" alt="" />
                <p>
                    <span>图形验证码:</span>
                    <input type="text" v-model="form.codeNumber" />
                </p>
                <div>
                    <button @click="() => {
                        this.controlImgCodeDialog = false;
                    }
                    ">
                        取消
                    </button>
                    <button @click="confirm(form.codeNumber)">确定</button>
                </div>
            </div>

        </div>
        <div class="floatbox">
            <img src="/activity/firstsignature/float.png" alt="">
            <div class="codeBoxs">
                <canvas class="canvasCode" ref="qrcodeCanvas"></canvas>


            </div>
        </div>
        <div class="content">
            <div class="part">
                <div class="part1">

                    <img class="partbox" src="/activity/firstsignature/cart.png" alt="">
                    <div class="rule" @click="showDialogs"></div>
                    <img class="button1" @click="tosCroll" src="/activity/firstsignature/button1.png" alt="">
                    <img class="button" @click="live800" src="/activity/firstsignature/button.png" alt="">

                    <div class="part2 clearfix">

                        <img class="partbox" src="/activity/firstsignature/cart1.png" alt="">


                    </div>

                </div>



                <div class="part3">
                    <img class="partbox" src="/activity/firstsignature/cart2.png" alt="">

                    <img class="button" @click="tosCroll" src="/activity/firstsignature/button3.png" alt="">

                </div>
            </div>
            <contactus-vue></contactus-vue>

        </div>
        <div class="wapcontent">
            <div class="part">
                <div class="part1">

                    <img src="/activity/firstsignature/wap/cart.png" alt="">
                    <div class="rule" @click="showDialogs">

                    </div>
                    <img class="button" @click="tosCroll" src="/activity/firstsignature/wap/button1.png" alt="">
                    <img class="button1" @click="live800" src="/activity/firstsignature/wap/button.png" alt="">
                    <div class="part2 clearfix">

                        <img src="/activity/firstsignature/wap/cart1.png" alt="">

                    </div>

                </div>



                <div class="part3">
                    <img src="/activity/firstsignature/wap/cart2.png" alt="">
                    <img src="/activity/firstsignature/wap/button2.png" class="button" @click="tosCroll" alt="">


                </div>
            </div>
        </div>

        <!-- 登录注册 -->
        <el-dialog :visible.sync="loginDialog" :showClose="false" width="0px" height="50px" custom-class="loginDialogs">
            <div class="loginDialogs">
                <img class="closer" @click="loginDialog = false" src="/activity/Millionsubsidy/close.png" alt="" />
                <img class="success" src="/activity/Millionsubsidy/success.png" alt="">
                <div class="conts">
                    <span>您的账号：{{ account }}</span><br />
                    <span>密码：{{ password }}</span>
                </div>
                <div class="buttoms">
                    <img @click="toActivity" v-if="isApp" src="/activity/Millionsubsidy/wap/activity.png" alt="">
                    <img @click="downloadApp" v-else src="/activity/Millionsubsidy/download.png" alt="">
                    <img @click="loginDialog = false" src="/activity/Millionsubsidy/button1.png" alt="">

                </div>
            </div>
        </el-dialog>
        <!-- 活动规则 -->
        <div class="popup" v-if="controlPop">
            <span @click="closePop" class="closer1">X</span>
            <ul class="popContent">
                <li class="top-tit">
                    十五载星河同耀，首签臻享 588 元现金 超多豪礼接踵而至
                </li>

                <li>
                    <span>活动周期：</span>
                    即日起一{{ getLastDayOfMonth() }}

                </li>
                <li>
                    <span>第一阶段</span><br />
                    <span>注册秒领好礼</span><br />

                    1.人民币：用户注册成功后，立即可以领取人民币红包288 元，前往平台——我的钱包 中查看。<br />

                    2.美元赠金：注册即送588美元赠金，按照交易手数笔笔提取，前往平台——我的——赠金奖励 中查看。

                </li>
                <li>
                    <span>第二阶段</span><br />
                    <span>激活无限权益</span><br />

                    激活账户，根据24小时内入金层级不同获得300~900人民币不同额度的等额美元现金，详情参考下表，新客最超值推荐领取588元层级！想冲最大福利，直接选1188元层级，准没错！<br />

                    激活账户后，您的福利自动提取到交易账户进行交易使用，仅需在 7 天内完成对应手数交易，详情参考表格。完成后，该笔资金可提取可交易，无限制。​<br />

                    同时，享有入金即送等额美元赠金福利，仅限新户，充值越多，赠金越多，轻松降低交易成本，放大投资收益。<br />
                    <span>提醒：</span>活动7天逾期未完成要求，未提现成功，将视为自动放弃奖励权益，即该笔人民币资金会被扣回，您的其他权益不受影响。

                    如果7天内，新客完成最低层级3手的要求，作为保底，288元人民币的等额美金可以正常提取。



                </li>
                <li>

                    <table>
                        <tr>
                            <th>入金区间(美金)</th>
                            <th>现金红包(人民币)</th>
                            <th>美元现金(等额人民币)</th>
                            <th>总赠送额(人民币)</th>
                            <th>7日内提现手数(手)</th>

                        </tr>
                        <tr>
                            <th>100≤首入金&lt;300</th>
                            <th>288</th>
                            <th>0</th>
                            <th>288</th>
                            <th>3</th>
                        </tr>
                        <tr>
                            <th>300≤首入金&lt;500</th>
                            <th>288</th>
                            <th>300</th>
                            <th>588</th>
                            <th>5</th>
                        </tr>
                        <tr>
                            <th>500≤首入金&lt;1000</th>
                            <th>288</th>
                            <th>600</th>
                            <th>888</th>
                            <th>8</th>
                        </tr>
                        <tr>
                            <th>1000≤首入金</th>
                            <th>288</th>
                            <th>900</th>
                            <th>1188</th>
                            <th>12</th>
                        </tr>

                    </table>
                </li>
                <!-- <li>
                    <span>第三阶段</span><br />
                    <span>绝对独家保障！</span>7日亏损全险<br />
                    新人首入200美金以上者，即可7天内享平台补贴，有效期内累计交易亏损达到交易补贴额度，即可获得对应现金<br />

                    1.补贴获得的美元现金和美元赠金，7日后达标自动打入账户余额。<br />

                    2.得到的现金可当真实资金使用，可交易可提现，提现时无手数要求。<br />

                    3.补贴仅能获得一次，无法重复获取。
                </li>


                <li>

                    <table>
                        <tr>
                            <th>层级</th>
                            <th>7日累计亏损</th>
                            <th>补贴方案</th>

                        </tr>
                        <tr>
                            <th>L1</th>
                            <th>≥$5,000</th>
                            <th>$1，000美元现金+$4，000美元赠金</th>
                        </tr>
                        <tr>
                            <th>L2</th>
                            <th>≥$10,000</th>
                            <th>$2，000美元现金+$8,000美元赠金</th>
                        </tr>
                        
                    </table>
                </li> -->
                <li>
                    <span>备注说明</span><br />
                    现金红包/人民币红包： 以人民币形式发放，用户可前往平台——我的钱包 中查看。<br />

                    人民币红包及人民币等额的美元现金，系统统一采用固定汇率7，并取整的形式来计算，并打入交易账户。<br />

                    美元现金：以美元形式发放至交易账户，可用作交易，满足提取条件后，可提取也可交易，无特殊限制。<br />

                    美元赠金：是美元形式的赠金，不可用于交易，按照交易手数笔笔提取，前往平台——我的——赠金奖励 中查看。<br />

                    为保证客户账户资金的配置，当客户获得总赠送588及以上人民币的层级，其账户强平比例调整为50%，活动结束后恢复。
                    <br />
                </li>
                <li>
                    <span>注意事项</span><br />
                    1. 参加原新用户活动的客户，无法重复参加该活动；<br />

                    2. 同一真实交易账户不可被多次邀请参加；<br />

                    3. 交易手数的计算：本活动只针对伦敦金伦敦银交易的手数计算，开仓一手再平仓一手，如此来回为一手；<br />

                    4.
                    若判定客户交易存在异常，例如恶意套利行为、短时间内如1分钟频繁进出经平台审核后实属剥头皮交易...等，公司皆有权收回相应交易优惠，本公司保留随时修订、暂停、终止本活动及任何相关规则条款之权利及其解释权。
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { verifyImgCode, quickRegister } from '../../../../api/info'
import ContactusVue from "../../Contactus.vue";
import { queryConfigValue, getFakebonus } from '@/apis/common';
import userSign from '@/mixins/userSign';
import { mapState, mapActions } from "vuex";
import { setToken, getToken, deleteToken } from "../../../../utils/cookies.js";
import { generateQRCode } from "../../../../utils/tools";

export default {
    components: {
        ContactusVue

    },
    mixins: [userSign],
    data() {
        return {

            navBarFixed: false,
            scroll: "",
            screenWidth: null,
            slider: true,
            showDialog: false,
            formattedDateString: '',
            timer: null,
            qrCodeUrl: '',
            loginDialog: false,//注册成功弹框
            account: '',//账号
            password: '',//密码
            isApp: false,//是否App进入 
            form: {
                phone: '',
                code: '',
                codeNumber: '',
            },
            tabbarShow: true,
            isApp: false,
            controlPop: false
        };
    },

    mounted() {

        const { origin } = window.location;
        const channel = sessionStorage.getItem('channel');
        console.log('下载地址-------------------', channel)
        let url = origin + '/subject/download?channel=' + channel
        const icon = require('../../../../static/index/hongshi.jpg')
        generateQRCode(url, this.$refs.qrcodeCanvas, icon)

        //获取屏幕尺寸
        this.screenWidth = document.body.clientWidth
        window.addEventListener("scroll", this.handleScroll);
        window.onresize = () => {
            return (() => {
                this.screenWidth = document.body.clientWidth;
            })()
        };


    },
    destroyed() {

    },
    watch: {
        screenWidth: function (n) {
            if (n <= 500) {
                // this.$router.push({
                //     name: "sc_2024wap",
                //     query: this.$route.query || {},
                // });
            }
        },
    },
    created() {
        console.log('传递数据------', this.$route.query)
        this.$emit("controlShow", true);
        // 判断是否是App登录进来
        if (this.$route.query.from) {
            const queryData = this.$route.query;
            const { accessKey = '', from = '' } = queryData;
            if (from === 'app_pm') {
                this.isApp = true;
                this.tabbarShow = false

            }
            console.log('App数据----------', queryData)
            if (accessKey) {
                setToken(accessKey)
            }
            if (from === 'app_pm' && !accessKey) {
                deleteToken();
            }
            const token = getToken();
            console.log('token', token)

        }

        else {

        }

    },
    methods: {
        // 下载APP
        downloads() {
            var u = navigator.userAgent;
            if (/(iPhone|iPad|iPod|iOS)/i.test(u)) { //苹果
                try {
                    window.webkit.messageHandlers.gotoRegisterReal.postMessage('1');
                } catch (error) {
                    window.open('https://apps.apple.com/cn/app/id1598072476');
                }
            } else { // 安卓
                try {
                    window.android.gotoRegisterReal();
                } catch (error) {
                    window.open('https://oss.0790jiaxiao.com/HS/software/hs_9999.apk');
                }
            }
        },
        getLastDayOfMonth() {
            const date = new Date();
            const year = date.getFullYear();
            const month = date.getMonth() + 1;
            const lastDayOfMonth = new Date(year, month, 0);
            // 获取最后一天的日期
            const lastDate = lastDayOfMonth.getDate();
            return month + '月' + lastDate + '日'
        },
        confirm(attr) {
            if (attr) {
                let data = {
                    Mobile: this.form.phone,
                    Token: this.guid,
                    ImgCode: Number(attr),
                }
                // 获取图片验证码接口
                verifyImgCode(data).then(res => {
                    if (res.IsSuccess) {
                        this.$message({
                            message: res.Data,
                            type: 'success'
                        });
                        // this.form.code = res.data;
                        this.verControl = !this.verControl;
                        this.controlImgCodeDialog = false;
                    } else {
                        this.$message({
                            message: res.Data,
                            type: 'warning',
                        });
                        this.controlImgCodeDialog = false;
                    }
                })
            } else {
                this.$message({
                    message: '请输入图片验证码结果!',
                    type: 'warning'
                });
            }
        },
        // 前往活动
        toActivity() {
            if (this.$route.query) {
                if (this.$route.query.accessKey) {
                    window.open(window.location.origin + '/activity/MillionsubsidyDetail/index')
                } else {
                    // 在安卓app
                    if (window.android) {
                        window.android.gotoLogin();
                        return
                    }
                    // 在ios
                    if (window.webkit) {
                        window.webkit.messageHandlers.gotoLogin()
                        return
                    }
                }
            }
        },
        showDialogs() {
            this.controlPop = true

        },
        closePop() {
            this.controlPop = false
        },



        // 点击获取焦点
        focusInput() {
            this.$refs.inputElement.focus();
        },

        // 返回上级页面
        goback() {
            window.location.href = window.location.origin;
        },
        // 控制顶部的定位
        handleScroll() {
            this.scroll =
                document.documentElement.scrollTop + document.body.scrollTop; //获取滚动后的高度
            if (this.scroll > 90) {
                this.navBarFixed = true;
            } else {
                this.navBarFixed = false;
            }
        },
        // 提交手机号验证码
        submit(form) {
            if (form.phone && form.code) {
                this.handleRegister().then((res) => {
                    console.log('注册信息------', res)
                    this.loginDialog = true

                    localStorage.setItem('token', res.Token);
                    localStorage.setItem('account', res.account);
                    this.account = res.account
                    this.password = res.password
                }).catch(() => {
                })
            } else {
                this.$message({
                    message: '请输入手机号和验证码！',
                    type: 'warning',
                });
            }
        },
        // 回到顶部
        toTop() {
            document.documentElement.scrollTop = 0;
        },
        // 跳转到登录注册
        tosCroll() {

            const targetElements = this.$refs.targetTops;
            const targetPosition = targetElements.offsetTop
            window.scrollTo({
                top: targetPosition,
                behavior: "smooth",
            });
        },

        // 客服链接
        live800() {
            window.open(
                this.$parent.live800Url
            );
        },
        // 下载App
        downloadApp() {
            var u = navigator.userAgent;
            if (/(iPhone|iPad|iPod|iOS)/i.test(u)) { //苹果
                try {
                    window.webkit.messageHandlers.gotoRegisterReal.postMessage('1');
                } catch (error) {
                    window.open(this.$parent.iosUrl);
                }
            } else { // 安卓
                try {
                    window.android.gotoRegisterReal();
                } catch (error) {
                    window.open(this.$parent.androidUrl);
                }
            }
        },



    },
    deactivated() {
        clearInterval(this.animate)
    },
    beforeDestroy() {
        clearInterval(this.animate)
    },

};
</script>

<style lang="less" scoped>
.box {
    width: 100%;
    // overflow-x: hidden;
    // height: 6215px;

    position: relative;

    .tabbar {
        width: 100%;
        padding: 0 10%;
        box-sizing: border-box;
        background-color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: space-between;

        img {
            margin: 20px 50px;
            width: 130px;
        }

        .downloads {
            width: 167px;
            height: 50px;
            border-radius: 20px;
            background: #ff0909;
            text-align: center;
            line-height: 50px;
            color: #fff;
            font-weight: 600;
            cursor: pointer;
        }
    }


    .navBarFixed {
        position: fixed;
        top: 0;
        z-index: 999;
    }

    .banner {
        width: 100%;

        display: block;
    }



    .wapbanner {
        width: 100%;
        display: none;
    }

    #login {
        width: 30%;
        height: 20vw;
        margin: 0 auto;
        background: url(/activity/firstsignature/bg1.png) no-repeat;
        background-size: 100% 100%;
        border-radius: 10px;
        padding: 132px 0 58px;
        position: absolute;
        top: 2vw;
        right: -2%;
        transform: translate(-50%, 0);
        display: block;

        .login-flex {
            display: flex;
            align-items: center;
            justify-content: center;
            padding-top: 100px;
        }


        .interactive {
            width: 70%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;

            input:focus {
                outline: none;
            }

            input {
                width: 80%;
                height: 3vw;
                background: #fff4e5;
                border: 1px solid #fff;
                border-radius: 10px;
                font-size: 16px;
                text-indent: 25px;
                list-style: none;
                border: 1px solid #feb869;
                // color: #ffb180;
            }

            .codeBox {
                width: 80%;
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;
                margin: 16px 0 26px 0;

                input {
                    width: 100%;
                }

                span {
                    width: 160px;
                    height: 3vw;
                    line-height: 3vw;
                    font-size: 16px;
                    border-radius: 10px;
                    background: linear-gradient(to bottom, #ffefcc, #ffc994);
                    width: 142px;

                    background: #ff9625;

                    text-align: center;
                    color: #fff;
                    position: absolute;
                    top: 0vw;
                    right: 0px;
                    cursor: pointer;
                }
            }

            .loginBtn {
                width: 20%;
                cursor: pointer;
                position: relative;
                top: 15px;
            }
        }

        .codeDialog {
            width: 500px;
            height: 250px;
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background-color: #fee6e4;
            border-radius: 15px;
            z-index: 99;
            border: 1px solid #ffdbdb;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;

            img {
                width: 120px;
                margin-bottom: 0;
            }

            p {
                span {
                    color: #5f0e15;
                    font-size: 18px;
                    font-weight: 600;
                }

                input {
                    width: 150px;
                    height: 30px;
                    background-color: #ffffff;
                    border: none;
                    margin-left: 10px;
                    text-indent: 10px;
                    color: #5f0e15;
                    font-size: 16px;
                }
            }

            div {
                display: flex;
                justify-content: center;
                align-items: center;

                button {
                    width: 100px;
                    height: 40px;
                    border: 1px solid #f64b44;
                    background-color: #ffffff;
                    color: #f64b44;
                    font-size: 18px;
                    border-radius: 8px;
                    margin: 0 10px;
                }

                button:nth-child(2) {
                    background-color: #f64b44;
                    color: #ffffff;
                }
            }
        }

        .buttom {
            width: 240px;
            height: 54px;
            margin: 0 auto;

            img {
                width: 100%;

            }

        }

    }

    .waplogin {
        width: 100%;
        height: 500px;
        margin: 0 auto;
        background: url(/activity/firstsignature/wap/bg1.png) no-repeat;
        background-size: 100% 100%;
        border-radius: 10px;
        padding: 60% 20px 20px;
        position: absolute;
        top: 11%;
        right: 2%;
        left: -2%;
        box-sizing: border-box;

        display: none;

        .login-flex {
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .interactive {
            width: 80%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;

            input:focus {
                outline: none;
            }

            input {
                width: 90%;
                height: 40px;
                background: #fff4e5;
                border: 1px solid #fff;
                border-radius: 10px;
                font-size: 16px;
                text-indent: 25px;
                list-style: none;
                border: 1px solid #ff9625;
                // color: #ffb180;
            }

            .codeBox {
                width: 90%;
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;
                margin: 16px 0 26px 0;

                input {
                    width: 100%;
                }

                span {
                    width: 100px;
                    height: 44px;
                    line-height: 40px;
                    font-size: 16px;
                    border-radius: 10px;
                    background: linear-gradient(to bottom, #ffefcc, #ffc994);
                    width: 102px;

                    background: #ff9625;

                    text-align: center;
                    color: #fff;
                    position: absolute;
                    top: 0vw;
                    right: 0px;
                    cursor: pointer;
                }
            }

            .loginBtn {
                width: 20%;
                cursor: pointer;
                position: relative;
                top: 15px;
            }
        }

        .codeDialog {
            width: 500px;
            height: 250px;
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background-color: #fee6e4;
            border-radius: 15px;
            z-index: 99;
            border: 1px solid #ffdbdb;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;

            img {
                width: 120px;
                margin-bottom: 0;
            }

            p {
                span {
                    color: #5f0e15;
                    font-size: 18px;
                    font-weight: 600;
                }

                input {
                    width: 150px;
                    height: 30px;
                    background-color: #ffffff;
                    border: none;
                    margin-left: 10px;
                    text-indent: 10px;
                    color: #5f0e15;
                    font-size: 16px;
                }
            }

            div {
                display: flex;
                justify-content: center;
                align-items: center;

                button {
                    width: 100px;
                    height: 40px;
                    border: 1px solid #f64b44;
                    background-color: #ffffff;
                    color: #f64b44;
                    font-size: 18px;
                    border-radius: 8px;
                    margin: 0 10px;
                }

                button:nth-child(2) {
                    background-color: #f64b44;
                    color: #ffffff;
                }
            }
        }

        .buttom {
            width: 80%;
            height: auto;
            margin: 0 auto;

            img {
                width: 100%;
                height: 100%;
            }

        }

    }

    .waplogins {
        position: absolute;
        top: 66%;
        right: 2%;
    }

    .logins {
        position: absolute;
        top: 9%;
    }

    .floatbox {
        position: fixed;
        top: 50%;
        right: 0;
        width: 280px;
        height: auto;
        z-index: 12;

        img {
            width: 100%;

        }

        .codeBoxs {
            position: absolute;
            top: 24%;
            left: 30%;

            .canvasCode {
                width: 120px;
                height: 120px;
            }

        }

    }


    .content {
        width: 100%;
        height: auto;
        // height: 5627px;
        box-sizing: border-box;
        margin: 0 auto;
        position: absolute;
        top: 31vw;
        background-size: 100% 90%;
        background: linear-gradient(to bottom, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.1)10%, #F8E8C8 11%, #F8E8C8 100%);
        display: block;


        .part {
            // max-width: 1400px;

            margin: 0 auto;
            padding: 0% 15% 10% 17%;
            background: url(/activity/firstsignature/bg.png) no-repeat;
            background-size: 100% 100%;

            .part1 {
                width: 100%;
                margin: 0 auto;
                position: relative;

                .button {
                    position: absolute;
                    bottom: -25%;
                    left: 28%;
                    z-index: 10;
                    cursor: pointer;
                }

                .button1 {
                    position: absolute;
                    top: 62%;
                    left: 28%;
                    z-index: 10;
                    cursor: pointer;
                }

                .rule {
                    width: 160px;
                    height: 40px;

                    position: absolute;
                    top: 10%;
                    right: 16%;
                    z-index: 10;
                    cursor: pointer;
                }

                .part2 {
                    position: absolute;
                    max-width: 1377px;
                    top: 60vw;
                    left: 6%;
                    margin: 0 auto;
                }

            }



            .request {
                margin-right: 20px;
            }



            .part3 {
                max-width: 1377px;
                // width: 1377px;
                // height: 1718px;
                margin: 0 auto;
                margin-top: 24vw;
                margin-left: 3vw;

                margin-bottom: 90px;

                padding-bottom: 30px;
                position: relative;

                .button {
                    position: absolute;
                    bottom: 10%;
                    left: 30%;
                    z-index: 10;
                    cursor: pointer;
                }



            }
        }
    }

    .wapcontent {
        display: none;
        width: 100%;
        height: auto;

        margin: 0 auto;
        padding-top: 72%;
        background: url(/activity/firstsignature/wap/bg.png) no-repeat;
        background-size: 100% 100%;

        .part {
            // max-width: 1400px;
            width: 100%;
            box-sizing: border-box;
            margin: 0 auto;
            // padding: 0 20px;


            .part1 {
                width: 100%;
                margin: 0 auto;
                position: relative;

                img {
                    width: 100%;
                    height: 100%;
                }

                .rule {
                    width: 100px;
                    height: 40px;

                    position: absolute;
                    top: 7%;
                    right: 10%;
                    z-index: 10;
                    cursor: pointer;
                }


                .part2 {
                    position: absolute;
                    width: 94%;
                    margin: 0 auto;
                    top: 78%;
                    left: 4%;

                    img {
                        width: 100%;
                        height: 100%;
                    }

                }

                .button {
                    position: absolute;
                    top: 64%;
                    left: 10%;
                    z-index: 10;
                    width: 80%;
                    height: 63px;
                }

                .button1 {
                    position: absolute;
                    bottom: -8%;
                    left: 10%;
                    z-index: 10;
                    width: 80%;
                    height: 63px;
                }

            }

            .part3 {
                width: 100%;
                margin: 0 auto;
                margin-top: 120px;

                margin-bottom: 90px;

                padding-bottom: 30px;
                position: relative;

                img {
                    width: 100%;
                    height: 100%;
                }

                .button {
                    position: absolute;
                    bottom: 10%;
                    left: 20%;
                    z-index: 10;
                    width: 60%;
                    height: 63px;

                }
            }
        }
    }

    .closer {
        width: 25px;
        height: auto;
        position: fixed;
        top: 0%;
        right: 0;
        cursor: pointer;

        z-index: 9999;
    }



    .dark {
        width: 100%;
        height: 100%;
        background: #000;
        opacity: 0.5;
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 101;
    }

    .loginDialogs {
        .closer {
            position: absolute;
            top: 40px;
            right: 0px;
            width: 50px;
            height: 50px;
        }

        position: relative;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        /deep/ .el-dialog__body {
            background: rgba(0, 0, 0, 0.5);

            border: none !important;
            width: 332px !important;
            height: 150px !important;
        }

        .conts {
            width: 300px;
            height: 96px;
            background: #fff1df;
            border-radius: 10px;
            position: absolute;
            bottom: 30%;
            right: 26%;
            z-index: 99;
            color: #000;
            font-weight: 600;
            line-height: 30px;
            font-size: 24px;
            text-align: center;
            padding-top: 20px;
            box-sizing: border-box;
        }

        .buttoms {
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            right: 8%;
            bottom: 10%;
            width: 80%;
            cursor: pointer;

            img:nth-child(1) {
                margin-right: 20px;
            }

            img {
                width: 40%;
                height: auto;
            }
        }



    }

    .popup {
        overflow-x: hidden;
        width: 1100px;
        height: 900px;
        border-radius: 20px;
        background: #fdf5e6;
        position: fixed;
        top: 57%;
        left: 50%;
        transform: translate(-50%; -50%);
        box-sizing: border-box;
        padding: 10px;
        box-shadow: 0px 0px 95px 0px rgba(43, 53, 105, 0.1);
        overflow-y: scroll;
        padding-bottom: 40px;
        z-index: 99999999999999;

        .closer1 {
            float: right;
            cursor: pointer;
            margin-top: 8px;
            margin-right: 10px;
        }

        .popContent {
            box-sizing: border-box;
            padding: 40px 50px 20px;

            .top-tit {
                font-weight: 600;
                color: #000;
                font-size: 30px;
                margin-bottom: 30px;
            }

            li {
                font-size: 18px;
                color: #a86e4f;
                line-height: 36px;

                span {
                    font-weight: 600;
                    color: #e34a3f;
                }

                img {
                    width: 100%;
                    height: auto;
                    margin: 20px 0;
                }

                table {
                    border: 1px solid #e34a3f;
                    border-radius: 15px;
                    width: 100%;

                    tr {
                        th {
                            text-align: center;
                            font-weight: 500;
                            line-height: 50px;
                            border-bottom: 1px solid #d2a765;
                            border-right: 1px solid #d2a765;
                            padding: 5px;
                        }

                        th:last-child {
                            border-right: 1px solid transparent;
                        }
                    }

                    tr:nth-child(1) {
                        th {
                            font-weight: 600;
                        }
                    }
                }
            }
        }
    }
}


@media screen and (max-width: 500px) {
    .box {
        .tabbar {
            width: 100%;
            padding: 0 5%;
            box-sizing: border-box;
            background-color: #ffffff;
            display: flex;
            align-items: center;
            justify-content: space-between;

            img {
                margin: 20px 0px;
                width: 100px;
            }

            .downloads {
                width: 83px;
                height: 30px;
                border-radius: 20px;
                background: #ff0909;
                text-align: center;
                line-height: 30px;
                color: #fff;
                font-weight: 600;
                cursor: pointer;
                font-size: 12px;
            }
        }

        .banner {
            display: none;
        }

        .wapbanner {
            display: block;
        }

        .content {
            display: none;
        }

        .wapcontent {
            display: block;
        }

        #login {
            display: none;
        }

        .waplogin {
            display: block;
        }

        .waplogin1 {
            position: absolute;
            top: 12%;
        }

        .floatbox {
            display: none;
        }

        .loginDialogs {
            .closer {
                position: absolute;
                top: 40px;
                right: 22px;
                width: 30px;
                height: 30px;
            }

            position: relative;
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);

            .success {
                width: 400px;
                height: auto;
            }

            /deep/ .el-dialog__body {
                background: rgba(0, 0, 0, 0.5);

                border: none !important;
                width: 332px !important;
                height: 150px !important;
            }

            .conts {
                width: 200px;
                height: 55px;
                background: #fff1df;
                border-radius: 10px;
                position: absolute;
                bottom: 31%;
                right: 26%;

                z-index: 99;
                color: #000;
                font-weight: 600;
                line-height: 18px;
                font-size: 14px;
                text-align: center;
                padding-top: 10px;
                box-sizing: border-box;
            }

            .buttoms {
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                right: 8%;
                bottom: 10%;
                width: 80%;
                cursor: pointer;

                img:nth-child(1) {
                    margin-right: 20px;
                }

                img {
                    width: 40%;
                    height: auto;
                }
            }



        }


        .popup {
            position: relative;
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 95%;
            height: 480px;
            box-shadow: 0px 0px 95px 0px rgba(187, 188, 192, 0.1);
            background-color: #fdf5e6;
            border-radius: 15px;
            overflow-y: scroll;
            z-index: 99999999;

            .closer1 {
                width: 16px;
                height: 30px;
                height: auto;
                position: absolute;
                top: 5px;
                right: 5px;
                font-size: 20px;
            }

            .popContent {
                box-sizing: border-box;
                padding: 10px;
                overflow: hidden;

                .top-tit {
                    font-size: 16px;
                    margin-top: 20px;

                }

                li {
                    font-size: 14px;
                    color: #a86e4f;
                    line-height: 24px;

                    span {
                        font-weight: 600;
                        color: #e34a3f;
                    }

                    img {
                        width: 100%;
                        height: auto;
                        margin: 20px 0;
                    }

                    table {
                        width: 100%;
                        border: 1px solid #e34a3f;
                        border-radius: 10px;

                        tr {
                            th {
                                text-align: center;
                                font-weight: 500;
                                line-height: 24px;
                                border-bottom: 1px solid #d2a765;
                                border-right: 1px solid #d2a765;
                                padding: 5px;
                            }

                            th:last-child {
                                border-right: 1px solid transparent;
                            }
                        }

                        tr:nth-child(1) {
                            th {
                                font-weight: 600;
                            }
                        }
                    }
                }
            }
        }





    }
}

@media screen and (min-width: 375px) {
    .box {

        .waplogin {
            position: absolute;
            top: 10%;

        }

        .logins {
            position: absolute;
            top: 8%;
        }
    }

}

//--------------------------110----------------------
@media screen and (min-width: 1724px) and (max-width: 1897px) {
    .box {
        #login {
            .buttom {
                width: 240px;
                height: 54px;
                margin: 0 auto;

                img {
                    width: 100%;
                }

            }
        }

        .content {
            .part {

                .part1 .partbox,
                .part2 .partbox,
                .part3 .partbox {
                    width: 94%;
                }

                .part1 {


                    .button1 {
                        position: absolute;

                        left: 25%;
                        width: 40%
                    }

                    .button {
                        position: absolute;
                        bottom: -38%;
                        left: 28%;
                        width: 40%
                    }

                    .rule {
                        // background: #e34a3f;
                        position: absolute;
                        right: 24%;
                    }
                }

                .part3 {
                    margin-top: 32vw;

                    .button {
                        width: 30%;
                        position: absolute;
                        left: 32%;
                    }
                }

            }
        }



        .floatbox {
            width: 240px;
        }

        .popup {
            height: 800px;
        }


    }

}

// ---------------125%------------------
@media screen and (min-width: 1517px) and (max-width: 1724px) {
    .box {
        #login {
            .buttom {
                width: 240px;
                height: 54px;
                margin: 0 auto;

                img {
                    width: 100%;
                }

            }
        }

        .content {
            .part {

                .part1 .partbox,
                .part2 .partbox,
                .part3 .partbox {
                    width: 94%;
                }

                .part1 {
                    .button1 {
                        width: 40%;
                        position: absolute;
                        left: 25%;
                    }

                    .button {
                        position: absolute;
                        bottom: -37%;
                        left: 28%;
                        width: 40%
                    }
                }

                .part3 {
                    margin-top: 32vw;

                    .button {
                        width: 30%;
                        position: absolute;
                        left: 32%;
                    }
                }


            }
        }



        .floatbox {
            width: 240px;
        }


    }
}

// -------------------150%--------------
@media screen and (min-width: 1264px) and (max-width: 1517px) {
    .box {
        #login {
            height: 12vw;

            .login-flex {
                padding-top: 0;
            }

            .buttom {
                width: 180px;
            }

            .interactive {
                input {
                    font-size: 14px;
                }

                .codeBox {
                    span {
                        width: 92px;
                        font-size: 14px;
                    }
                }
            }
        }

        .content {
            .part {

                .part1 .partbox,
                .part2 .partbox,
                .part3 .partbox {
                    width: 90%;
                }

                .part1 {


                    .button1 {

                        width: 40%;
                        position: absolute;

                        left: 22%;


                    }

                    .button {
                        position: absolute;
                        bottom: -41%;

                        width: 40%
                    }
                }

                .part2 {

                    position: absolute;
                    top: 52%;
                }

                .part3 {
                    margin-top: 34vw;

                    .button {
                        position: absolute;

                        left: 30%;
                        width: 30%
                    }
                }

            }
        }


        .floatbox {
            width: 200px;

            .codeBoxs {
                position: absolute;
                top: 24%;
                left: 30%;

                .canvasCode {
                    width: 90px;
                    height: 90px;
                }

            }
        }

    }
}
</style>